const isProd = location.hostname === 'bestill.rikstv.no';

export type BroadBandProduct = { name: 'Fiber 50' | 'Fiber 100' | 'Fiber 300'; price: number; originalPrice: number };

// TODO: should get this data from NGT response
export const Fiber100: BroadBandProduct = {
  name: 'Fiber 100',
  price: 570,
  originalPrice: 899,
};
// TODO: should get this data from NGT response
export const Fiber50: BroadBandProduct = {
  name: 'Fiber 50',
  price: 530,
  originalPrice: 799,
};

export const NGT_PARTNER_ID = 85;
export const NGTCommercialProductId = isProd ? 3079 : 3046;
/* Ala carte product so variations are (weirdly) handled by "ChannelId"*/
const NGTChannelIds = {
  Fiber50: isProd ? 272 : 274,
  Fiber100: isProd ? 273 : 273,
  Fiber300: isProd ? 274 : 272,
};
export const getNgtChannelId = (ngtPackageName: BroadBandProduct['name']): number => {
  switch (ngtPackageName) {
    case 'Fiber 50':
      return NGTChannelIds.Fiber50;
    case 'Fiber 100':
      return NGTChannelIds.Fiber100;
    case 'Fiber 300':
      return NGTChannelIds.Fiber300;
    default:
      throw new Error(`Unknown package name: ${ngtPackageName}`);
  }
};
